/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useCallback } from 'react';
import Toast from 'react-native-toast-message';
import SociollaText from '@components/sociolla/SociollaText';
import Input from '@components/form/Input';
import TableHeader from '@/screens/setting/target-setting/components/TableHeader';

import { currency } from '@global/helpers';
import { isWeb } from '@global/screens';
import Colors from '@global/colors';
import { MONTH_KEYS, MONTH_OBJ_NUMBERS } from '@/constants/target-settings';

import { showAlert } from '@/store/global';

import { MsB2b } from '@api/ms-b2b';

import { debounce } from 'lodash';

const tableWrapperStyle = {
  width: '100%',
  maxHeight: isWeb ? 'calc(100vh - 100px)' : '',
  backgroundColor: Colors.white,
  borderCollapse: 'collapse',
};

const tableBodyStyle = {
  padding: '12px 15px',
  position: 'relative',
};

const tableBodyText = {
  fontSize: 14,
};

const tableTotalData = {
  backgroundColor: Colors.blue5,
};

const tableColumnSticky = {
  minWidth: 150,
  position: 'sticky',
  left: 0,
  zIndex: 1,
};

const TableTargetSetting = ({
  index = -1,
  dispatch = null,
  prefixHeader = '',
  disabledEdit = false,
  tableStructures = [],
  tableHeader = [],
  tableData = [],
  editing = [],
  targetSettingType = '',
  customSalesTargetHeader = '',
  setTableData = () => {},
  setHasChanged = () => {},
  setEditing = () => {},
  onEdit = () => {},
}) => {
  const doChange = useCallback(
    debounce(async ({ data, idx = -1, body = '' }) => {
      let fieldKey = 'target_value';
      if (targetSettingType == 'product-focus-salesman') {
        fieldKey = data.field;
      }
      if (!data?.id) {
        fieldKey = 'value';
      }
      const finalValue = data?.value || 0;
      if (data?.id) {
        try {
          MsB2b.updateTargetSetting(data?.id, {
            [fieldKey]: finalValue,
          });
        } catch (error) {}
      } else {
        const newPayload = {};
        const keys = Object.keys(data.payload);
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          const fields = data.field.split('_');
          const fieldKey = fields[fields.length - 1];
          if (
            key.indexOf('brand_id_focus_') > -1 ||
            key.indexOf('sku_') > -1 ||
            key.indexOf('value_') > -1 ||
            key.indexOf('product_') > -1 ||
            key.indexOf('target_value_type_') > -1
          ) {
            if (`brand_id_focus_${fieldKey}` == key) {
              newPayload[key] = data.payload[key];
            } else {
              if (key.indexOf('brand_id_focus_') > -1) {
                newPayload[key] = '';
              }
            }
            if (`sku_${fieldKey}` == key) {
              newPayload[key] = data.payload[key];
            } else {
              if (key.indexOf('sku_') > -1) {
                newPayload[key] = '';
              }
            }
            if (`value_${fieldKey}` == key) {
              newPayload[key] = data.payload[key];
            } else {
              if (key.indexOf('value_') > -1) {
                newPayload[key] = '';
              }
            }
            if (`target_value_type_${fieldKey}` == key) {
              newPayload[key] = data.payload[key];
            } else {
              if (key.indexOf('target_value_type_') > -1) {
                newPayload[key] = '';
              }
            }
            if (`product_${fieldKey}` == key) {
              newPayload[key] = data.payload[key];
            }
          } else {
            newPayload[key] = data.payload[key];
          }
        }

        try {
          const response = await MsB2b.createTargetSetting({
            ...newPayload,
            [fieldKey]: finalValue,
          });
          if (response?.data?.data?._id) {
            const res = response.data.data;
            const oldData = JSON.parse(JSON.stringify(tableData));
            if (index > -1) {
              oldData[index].data[idx][body] = finalValue;
              oldData[index].data[idx].data[body] = res;
            } else {
              oldData[idx][body] = finalValue;
              oldData[idx].data[body] = res;
            }
            setTableData(oldData);
          }
        } catch (error) {
          console.log('error', error);
        }
      }
    }, 500),
    [],
  );

  const hasTotal = ![
    'product-focus-salesman',
    // 'sales-value-branch',
    // 'sales-value-salesman',
  ].includes(targetSettingType);

  return (
    <div
      style={{
        width: '100%',
        overflow: 'auto',
        borderRadius: 5,
        marginBottom: 15,
      }}>
      <table style={tableWrapperStyle}>
        <TableHeader
          prefixHeader={prefixHeader}
          tableHeader={tableHeader}
          customSalesTargetHeader={customSalesTargetHeader}
        />
        {(index > -1 ? tableData[index].data : tableData)?.length ? (
          <tbody>
            {(index > -1 ? tableData[index].data : tableData).map(
              (item, idx) => (
                <tr
                  style={{
                    backgroundColor: idx % 2 == 0 ? Colors.grey4 : Colors.white,
                  }}
                  key={`body-${idx}`}>
                  {tableStructures.map((child, childIdx) => (
                    <td
                      style={{
                        ...tableBodyStyle,
                        ...(childIdx == 0
                          ? {
                              ...tableColumnSticky,
                              backgroundColor:
                                idx % 2 == 0 ? Colors.grey4 : Colors.white,
                            }
                          : !(
                              child.body === 'salesman_code' ||
                              child.body === 'salesman_name' ||
                              child.body === 'brand'
                            )
                          ? { textAlign: 'right' }
                          : {}),
                        ...(childIdx == tableStructures.length - 1 && hasTotal
                          ? tableTotalData
                          : {}),
                      }}
                      onClick={(e) => {
                        if (!disabledEdit) {
                          if (targetSettingType == 'product-focus-salesman') {
                            const oldData = JSON.parse(
                              JSON.stringify(tableData),
                            );
                            let data = {};
                            if (index > -1) {
                              data = oldData[index].data[idx];
                            } else {
                              data = oldData[idx];
                            }
                            const field = data?.field;
                            if (field) {
                              const fields = field.split('_');
                              const fieldNumber = fields[fields.length - 1];
                              const item =
                                data?.month_detail?.[child.body]?.[
                                  targetSettingType
                                ];
                              if (
                                !item?.[`brand_id_focus_${fieldNumber}`]?.id ||
                                !item?.[`sku_${fieldNumber}`]
                              ) {
                                if (dispatch) {
                                  dispatch(
                                    showAlert({
                                      show: true,
                                      title: 'Error',
                                      description:
                                        'You cannot change value with empty Brand & SKU.',
                                      isConfirm: false,
                                    }),
                                  );
                                } else {
                                  Toast.show({
                                    text1:
                                      'You cannot change value with empty Brand & SKU.',
                                    type: 'error',
                                  });
                                }
                                return;
                              }
                            }
                          }
                          if (e.detail == 2 && item[child.body] == '-') {
                            const oldData = JSON.parse(
                              JSON.stringify(tableData),
                            );
                            if (index > -1) {
                              oldData[index].data[idx][child.body] = 0;
                            } else {
                              oldData[idx][child.body] = 0;
                            }
                            setTableData(oldData);
                          }
                          onEdit({
                            event: e,
                            index: idx,
                            childIndex: childIdx,
                          });
                        }
                      }}
                      key={`body-${idx}-${childIdx}`}>
                      {editing.indexOf(`body-${idx}-${childIdx}`) > -1 ? (
                        <Input
                          label=""
                          value={item[child.body]}
                          placeholder=""
                          isNumeric
                          onChangeText={(value) => {
                            const onChangeMonth = (data) => {
                              if (
                                isNaN(data?.month) ||
                                MONTH_KEYS.indexOf(child.body) > -1
                              ) {
                                data.month = MONTH_OBJ_NUMBERS[child.body];
                              }
                              return data;
                            };
                            const oldData = JSON.parse(
                              JSON.stringify(tableData),
                            );
                            const data = {
                              value: value,
                            };
                            if (index > -1) {
                              data.id =
                                oldData[index].data[idx]?.data?.[
                                  child.body
                                ]?._id;
                              data.data =
                                oldData[index].data[idx]?.data?.[child.body];
                              data.field =
                                oldData[index].data[idx]?.field || 'value';
                              data.payload = onChangeMonth(
                                oldData[index].data[idx]?.detail?.[
                                  targetSettingType
                                ],
                              );
                              oldData[index].data[idx][child.body] = value;
                            } else {
                              data.id = oldData[idx]?.data?.[child.body]?._id;
                              data.data = oldData[idx]?.data?.[child.body];
                              data.field = oldData[idx]?.field || 'value';
                              data.payload = onChangeMonth(
                                oldData[idx]?.detail?.[targetSettingType],
                              );
                              oldData[idx][child.body] = value;
                            }
                            setTableData(oldData);
                            doChange({
                              data: data,
                              body: child.body,
                              idx,
                            });
                          }}
                          onSubmitEditing={() => {
                            // let findData = tableData[idx];
                            // if (index > -1) {
                            //   findData = tableData[index].data[idx];
                            // }
                            // const payload = {
                            //   id: findData?.id,
                            //   value: findData?.target_value,
                            // };
                            // if (payload?.id) {
                            //   try {
                            //     MsB2b.updateTargetSetting(payload.id, {
                            //       target_value: payload?.value || 0,
                            //     });
                            //   } catch (error) {}
                            // }
                            const newEdtiting = JSON.parse(
                              JSON.stringify(editing),
                            );
                            const findIndex = newEdtiting.indexOf(
                              `body-${idx}-${childIdx}`,
                            );
                            if (findIndex > -1) {
                              newEdtiting.splice(findIndex, 1);
                              setEditing(newEdtiting);
                            }
                            setHasChanged(true);
                          }}
                        />
                      ) : (
                        <SociollaText
                          type={
                            childIdx == tableStructures.length - 1 && hasTotal
                              ? 'medium'
                              : 'regular'
                          }
                          style={tableBodyText}>
                          {item[child.body] == '--'
                            ? ''
                            : !isNaN(item[child.body])
                            ? currency(item[child.body])
                            : item[child.body] || '-'}
                        </SociollaText>
                      )}
                    </td>
                  ))}
                </tr>
              ),
            )}
          </tbody>
        ) : (
          <tbody>
            <tr
              style={{
                backgroundColor: Colors.white,
              }}>
              <td style={tableBodyStyle}>
                <SociollaText style={tableBodyText}>
                  Data not found.
                </SociollaText>
              </td>
            </tr>
          </tbody>
        )}
      </table>
    </div>
  );
};

export default React.memo(TableTargetSetting, (prev, next) => prev == next);
